<template>
  <div class="input" :class="{ valid: valid, invalid: valid === false }">
    <span class="input__name">{{ label }}</span>
    <div class="input__field">
      <textarea
        v-if="middle"
        :placeholder="placeholder"
        @input="validate"
        ref="input"
        class="textarea-middle"
      />
      <textarea
        v-if="big"
        :placeholder="placeholder"
        @input="validate"
        @keyup="resizeTextArea"
        ref="input"
        class="textarea-big"
        id="textarea-big"
      />
      <input
        v-if="!middle && !big"
        name="name"
        type="text"
        :placeholder="placeholder"
        @change="validate"
        @click="show"
        @blur="hide"
        ref="input"
      />
      <button v-if="removable" class="input__remove" @click="removeIt">
        <svg-icon type="trashcan" />
      </button>
      <CTooltip :action="show_tooltip" :position="tooltip_position">{{
        tooltip_data
      }}</CTooltip>
    </div>
  </div>
</template>

<script>
import CTooltip from "./CTooltip";
export default {
  name: "CInput",
  components: { CTooltip },
  props: [
    "big",
    "middle",
    "type",
    "placeholder",
    "required",
    "label",
    "initVal",
    "tooltip",
    "tooltip_position",
    "alarm_msg",
    "removable"
  ],
  data() {
    return {
      show_tooltip: false,
      tooltip_data: this.tooltip,
      valid: this.initVal ? !!this.initVal : null,
      isMobile: window.innerWidth < 481
    };
  },
  mounted() {
    if (this.initVal) {
      this.$refs.input.value = this.initVal;
      if (this.valid) {
        this.$emit("valid");
      }
    }
  },
  methods: {
    resizeTextArea(e) {
      if (e.target.value.length < 400 && !this.isMobile) {
        this.$refs.input.style.minHeight = 158 + "px";
      } else if (e.target.value.length < 400 && this.isMobile) {
        this.$refs.input.style.minHeight = 290 + "px";
      } else if (this.$refs.input.scrollHeight > 158 && !this.isMobile) {
        this.$refs.input.style.minHeight = this.$refs.input.scrollHeight + "px";
      } else if (this.$refs.input.scrollHeight > 289 && this.isMobile) {
        this.$refs.input.style.minHeight = this.$refs.input.scrollHeight + "px";
      }
    },
    removeIt() {
      this.$emit("removeit");
    },
    show() {
      if (this.tooltip && this.tooltip_data) {
        this.show_tooltip = true;
      }
    },
    hide() {
      if (this.valid) {
        this.show_tooltip = false;
      }
    },
    validate(e) {
      let value = e.target.value;
      let empty = !value;
      let localValid = true;
      if (this.type === "number") {
        localValid = /\d+/.test(value);
      } else if (this.type === "email") {
        localValid = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          value
        );
      } else if (this.type === "latin") {
        localValid = /^[a-zA-Z0-9/:.@\-_]*$/.test(value);
      }
      if (this.placeholder === "Ссылка на страницу") {
        const prefixes = [
          { label: "Вконтакте", prefix: "vk.com" },
          { label: "Facebook", prefix: "instagram.com" },
          { label: "Одноклассники", prefix: "ok.ru" },
          { label: "Instagram", prefix: "fb.com" },
          { label: "Twitter", prefix: "twitter.com" },
          { label: "YouTube", prefix: "youtube.com" }
        ];
        const isURL = !!value.match("^https?://");
        const hasSlashes = !!value.split("").filter(i => i === "/").length;
        const prefix = prefixes.filter(i => i.label === this.label)[0].prefix;
        const isThisNetwork =
          this.label === "Facebook"
            ? !!value.match(`(www.)?(facebook.com/|${prefix})`)
            : !!value.match(`(www.)?${prefix}`);
        if ((isURL || hasSlashes) && !isThisNetwork) {
          localValid = false;
        }
      }

      this.valid = this.required ? !empty && localValid : localValid;
      this.valid ? this.$emit("valid") : this.$emit("invalid");
      if (this.tooltip_data) {
        this.show_tooltip = !this.valid;
      }
      if (!this.valid && this.alarm_msg) {
        this.tooltip_data = this.alarm_msg;
      } else {
        if (this.tooltip) {
          this.tooltip_data = this.tooltip;
        }
      }
      this.$emit("input", value);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vars.scss";

.input {
  display: flex;
  flex-direction: column;
  position: relative;

  &:not(:last-child) {
    margin-bottom: 20px;
  }

  @media #{$mobile} {
    margin-bottom: 20px;
  }

  input,
  textarea {
    border: 1px solid #cccccc;
    outline: none;
    border-radius: 5px;
    padding: 10px 15px;
    font-size: 16px;
    background: transparent;
    resize: none;
    font-family: "Inter", sans-serif;
    width: 100%;

    &:focus {
      border-color: #3479cc;
    }
  }

  &.valid input,
  &.valid textarea {
    border-color: #3479cc;
  }

  &.invalid input,
  &.invalid textarea {
    border-color: #ff0000;
  }

  .textarea-middle {
    height: 90px;
  }

  .textarea-big {
    min-height: 158px;
    overflow: hidden;
    transition-property: min-height;
    transition-duration: 1s;
    @media #{$mobile} {
      min-height: 290px;
    }
  }

  &__name {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 5px;
  }
  &__field {
    position: relative;
    display: flex;
    align-items: center;
  }
  &__remove {
    display: flex;
    padding: 10px;
    cursor: pointer;
    border: none;
    outline: none;
    background: none;
  }
}
</style>
